module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "services-calendar view"
  }, [_c('transition', {
    attrs: {
      "name": "v-transition-notification"
    }
  }, [(_vm.showNotification) ? _c('nks-notification', {
    attrs: {
      "eventsNbr": _vm.eventsNbr
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "v-transition-actions"
    }
  }, [(_vm.showAction) ? _c('nks-actions', {
    attrs: {
      "eventDate": _vm.selectedEventDate,
      "eventActions": _vm.selectedEventActions
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "v-transition-calendar"
    }
  }, [_c('full-calendar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCalendar),
      expression: "showCalendar"
    }],
    attrs: {
      "events": _vm.fcEvents,
      "firstDay": "1",
      "monthNames": _vm.monthNames,
      "weekNames": _vm.weekNames
    },
    on: {
      "eventClick": _vm.eventClick
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-cce4e846!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Calendar.vue
// module id = 42
// module chunks = 0